export const RESOURCE_NOT_FOUND = 404;
export const RESOURCE_GONE = 410;

export const RESOURCE_GONE_STATUSES = new Set([
  RESOURCE_NOT_FOUND,
  RESOURCE_GONE,
]);
